import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import rabonapp from "../../Assets/Projects/rab.png";
import tiempito from "../../Assets/Projects/tiemp.png";
import noti from "../../Assets/Projects/noti.png";
import mueb from "../../Assets/Projects/mueb.png";
import cob from "../../Assets/Projects/cob.png";
import pos from "../../Assets/Projects/POS.png";
import invitacion from "../../Assets/Projects/InvitacionPremium.png";
import reciboSueldo from "../../Assets/Projects/Recibo.png";
import LodKeren from "../../Assets/Projects/LodKeren.png";
// import anana from "../../Assets/Projects/an.jpg";
// import anana1 from "../../Assets/Projects/an1.png";
// import mws from "../../Assets/Projects/mws.jpg";
// import pel from "../../Assets/Projects/pel.jpg";
// import hisoka from "../../Assets/Projects/h.png";



function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          Mis <strong className="purple">proyectos </strong>
        </h1>
        <p style={{ color: "white" }}>
          Aquí podrás ver mis proyectos en los que trabajé.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={invitacion}
              isBlog={false}
              title="Invitación Virtual Premium"
              description="Experiencia web interactiva para compartir una invitación digital de forma elegante, personalizada y accesible desde cualquier dispositivo."
              demoLink="https://invitacion-premium-two.vercel.app"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={LodKeren}
              isBlog={false}
              title="Tienda Lo d' Keren"
              description="Sitio web comercial para Lo d' Keren, con una presentación moderna de productos de bienestar, bebidas funcionales y cuidado dermatológico."
              demoLink="https://www.dxnlodkeren.com.ar"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={reciboSueldo}
              isBlog={false}
              title="Generador de Recibos de Sueldo"
              description="Sistema portable que moderniza un flujo originalmente desarrollado en Tkinter para generar recibos de sueldo según el régimen laboral argentino 2026, utilizando datos provenientes de Memory Worky."
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={mueb}
              isBlog={false}
              title="Mueblería Jota Hermanos"
              description="Proyecto de E-commerce para la marca 'Hermanos Jota'. El mismo fue desarrollado para la Beca Fullstack Developer | Banco Santander & ITBA."
              demoLink="https://e-commerce-muebleria-hnos-jota.vercel.app"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={cob}
              isBlog={false}
              title="Cobertores Arroyito"
              description="Página web desarrollada para la empresa 'Cobertores Arroyito', en la cual se pueden ver los productos que ofrecen, contactarse con ellos y más."
              demoLink="https://cobertoresarroyito.com.ar"
            />
          </Col>
          
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={pos}
              isBlog={false}
              title="Sistema de Punto de Venta (POS) Full Stack"
              description="Solución integral para la gestión de comercios minoristas. Incluye control de inventario en tiempo real, facturación con lector de códigos de barras, 
              dashboard de ganancias y gestión de usuarios con roles (Admin/Cajero). Diseño 100% responsivo adaptado para escritorio y dispositivos móviles."
              demoLink="https://sistema-ventas-0nf6.onrender.com"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={noti}
              isBlog={false}
              title="NotiApp"
              description="Una aplicación web de noticias, en las que podes subir tus articulos, noticias, buscar y contactarte con personas. Desarrollada con JavaScript y React, consumiendo una API que nos otorgó la universidad."
              ghLink="https://github.com/Nachzzz/Noti-app"
              demoLink=""
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={rabonapp}
              isBlog={false}
              title="Rabonapp"
              description="Una aplicación para organizar partidos de fútbol 5, en la que puedes contactarte con jugadores, formar o unirte a equipos, organizar encuentros de fútbol y más. La misma desarrollada con React y Flask, MySQL para su API."
              ghLink="https://rabonapp.vercel.app/"
              demoLink=""
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={tiempito}
              isBlog={false}
              title="Tiempito"
              description="Una aplicación en la que puedes buscar tu ciudad y ver los datos meteorológicos de la misma."
              ghLink="https://github.com/Nachzzz/Tiempito"
              demoLink="https://tiempito.vercel.app"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
